import LearningsDetailContainer from 'containers/LearningsDetailContainer/LearningsDetailContainer';

export default (props: any) => <LearningsDetailContainer {...props} />;
